import { memo } from 'react';
import PropTypes from 'prop-types';
import styles from './IncidentTimelineDesktopFilter.module.css';
import { NOTE_SUB_IDS, NOTE_GROUP_IDS, toggleFilterType, isNoteSubActive } from './timelineFilterUtils';

function IncidentTimelineDesktopFilter({ availableTypes, appliedTypes, onApply }) {
  const topTypes = availableTypes.filter(({ id }) => !NOTE_GROUP_IDS.has(id));
  const noteGroupTypes = availableTypes.filter(({ id }) => NOTE_GROUP_IDS.has(id));

  const noteSubActive = isNoteSubActive(appliedTypes);

  function renderPill({ id, label }, extraClass) {
    const isActive = appliedTypes.has(id) || (id === 'note' && noteSubActive);
    return (
      <button
        key={id}
        type="button"
        data-type={id}
        className={[styles.pill, extraClass, isActive ? styles.pillActive : ''].filter(Boolean).join(' ')}
        onClick={() => onApply(toggleFilterType(appliedTypes, id))}
        aria-pressed={isActive}
      >
        {label}
      </button>
    );
  }

  return (
    <div className={styles.filterRow} role="group" aria-label="Filter timeline">
      <span className={styles.filterLabel}>Filter by:</span>
      <div className={styles.pillList}>
        {topTypes.map((t) => renderPill(t, null))}

        {noteGroupTypes.length > 0 && (
          <div className={styles.noteGroup} role="group" aria-label="Note filters">
            {noteGroupTypes.map((t) =>
              renderPill(t, NOTE_SUB_IDS.has(t.id) ? styles.pillSub : null)
            )}
          </div>
        )}
      </div>
      {appliedTypes.size > 0 && (
        <button
          type="button"
          className={styles.clearAll}
          onClick={() => onApply(new Set())}
          aria-label="Clear all filters"
        >
          Clear all
        </button>
      )}
    </div>
  );
}

IncidentTimelineDesktopFilter.propTypes = {
  availableTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  appliedTypes: PropTypes.instanceOf(Set).isRequired,
  onApply: PropTypes.func.isRequired,
};

export default memo(IncidentTimelineDesktopFilter);
